import { cn } from '@/lib/utils'
import { IconFolderOpenAngledOutline } from '@icons/IconFolderOpenAngledOutline'
import { motion } from 'motion/react'

export const presenceAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2, ease: 'easeOut' as const },
}

export const NoSearchResultsDisplay = ({ text, className }: { text?: string; className?: string }) => {
  return (
    <motion.div
      className={cn('flex h-full w-full items-center justify-center pt-20', className)}
      {...presenceAnimation}
    >
      <div className="flex flex-col items-center gap-y-10">
        <IconFolderOpenAngledOutline className="size-20 text-foreground/5" />
        <p className="text-lg text-muted-foreground">{text || 'No results found'}</p>
      </div>
    </motion.div>
  )
}
